import { createForm } from '../../../factories'

export default createForm(['groupIDs'])



// WEBPACK FOOTER //
// ./src/store/modules/members/forms/relateGroups.js